const sections = [
  {
    number: '01',
    title: 'Bookings & Payment',
    content: [
      'A booking is only confirmed once the checkout process has been completed in full via BookWhen through athomson.uk, and payment has been received. Provisional or incomplete bookings do not guarantee a place on a class.',
      'Payment is due in full at the point of checkout. No booking will be processed without payment.',
    ]
  },
  {
    number: '02',
    title: 'Pay-As-You-Go Sessions',
    content: [
      'Individual session bookings are non-refundable once payment has been made, except where the purchaser is entitled to a refund under the 14-day statutory cooling-off period provided by the Consumer Contracts Regulations 2013. To request a cancellation within this period, the purchaser must contact A. Thomson within 14 days of purchase, provided the session has not yet taken place.',
      'Where a student cancels a pay-as-you-go session with more than 24 hours notice, credit will be offered toward a future session of the same type. Cancellations made with less than 24 hours notice will be forfeited in full. No credit, refund, or alternative session will be offered.',
    ]
  },
  {
    number: '03',
    title: 'Class Cancellation by A. Thomson',
    content: [
      'A. Thomson reserves the right to cancel a scheduled class at any time. Where a class is cancelled, affected bookings will be moved to an alternative date. If a student is unable to attend the rearranged date, credit will be offered toward a future class in place of the original session.',
    ]
  },
  {
    number: '04',
    title: 'Class Passes',
    content: [
      'Class passes are valid for 6 months from the date of purchase. The expiry date will be shown at the time of booking and in your confirmation email.',
      'Class passes cannot be extended under any circumstances, regardless of the reason for non-use.',
      'Any sessions unused at the expiry date are forfeited. No credit, refund, or other compensation will be provided for unused sessions.',
      'Class passes are personal to the purchaser and cannot be transferred, shared, or resold to another person.',
    ]
  },
  {
    number: '05',
    title: 'Refunds & Cooling-Off Period',
    content: [
      'Class passes are non-refundable, except where the purchaser is entitled to a refund under the 14-day statutory cooling-off period provided by the Consumer Contracts Regulations 2013.',
      'To request a cancellation within this period, the purchaser must contact A. Thomson within 14 days of purchase, provided no sessions from the pass have yet been used. Once a session has been used, or once the 14-day period has passed, the pass becomes non-refundable.',
    ]
  },
  {
    number: '06',
    title: 'Rescheduling & Late Cancellation',
    content: [
      'Students may reschedule a booking up to 24 hours before the scheduled session start time. Rescheduling should be done directly through the student\'s BookWhen account at athomson.uk.',
      'If no suitable alternative time is available through the booking system, students may contact A. Thomson directly by emailing audrey@athomson.uk to request a specific timeslot. This is subject to availability and cannot be guaranteed.',
      'Cancellations or rescheduling requests made with less than 24 hours notice will be forfeited in full. No credit, refund, or alternative session will be offered.',
    ]
  },
  {
    number: '07',
    title: 'Health, Safety & Liability',
    content: [
      'Aerial arts is a physical activity that carries inherent risk. By booking a session, students confirm that they are in good physical health and have no medical condition, injury, or disability that would make participation unsafe without medical clearance.',
      'It is the student\'s responsibility to inform A. Thomson of any relevant medical conditions, injuries, or physical limitations prior to their first session, and to notify A. Thomson of any changes to their health that may affect their ability to participate safely.',
      'A. Thomson reserves the right to refuse participation or modify a session where it is reasonably believed that continuing poses a risk to the student\'s safety.',
      'Participation in all sessions is at the student\'s own risk. A. Thomson accepts no liability for injury, loss, or damage arising from participation, except where such liability cannot be excluded by law.',
    ]
  },
  {
    number: '08',
    title: 'Code of Conduct',
    content: [
      'Students are expected to treat A. Thomson, other students, and any studio environment with respect. A. Thomson reserves the right to refuse or terminate a booking where conduct is deemed inappropriate, unsafe, or disruptive. No refund will be issued in such circumstances.',
    ]
  },
  {
    number: '09',
    title: 'Photography & Media Consent',
    content: [
      'A. Thomson may occasionally photograph or film sessions for use on social media and marketing materials. Students who do not wish to be photographed or filmed should notify A. Thomson in writing prior to their session. Opting out will be respected in full and will not affect the student\'s participation in any way.',
    ]
  },
  {
    number: '10',
    title: 'Data Protection',
    content: [
      'Personal data collected at the point of booking is held and processed in accordance with UK GDPR. Data is used solely for the purpose of administering bookings and communicating with students about their sessions. Data will not be shared with third parties except where required by law. For any data-related queries, contact audrey@athomson.uk.',
    ]
  },
  {
    number: '11',
    title: 'Force Majeure',
    content: [
      'A. Thomson will not be liable for failure to deliver a session where such failure is caused by circumstances beyond reasonable control, including but not limited to illness, injury, venue closure, extreme weather, or other events that make delivery impossible or unsafe. In such cases, A. Thomson will endeavour to reschedule the affected session or offer credit.',
    ]
  },
  {
    number: '12',
    title: 'Workshops & One-Off Events',
    content: [
      'These terms apply to regular class bookings. Workshops and one-off events may be subject to additional or different terms, which will be communicated clearly at the point of booking.',
    ]
  },
  {
    number: '13',
    title: 'Changes to These Terms',
    content: [
      'A. Thomson reserves the right to update these terms at any time. The current version will always be published at athomson.uk. Continued use of the booking service following any changes constitutes acceptance of the updated terms.',
    ]
  },
  {
    number: '14',
    title: 'Governing Law',
    content: [
      'These terms are governed by the laws of England and Wales. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts of England and Wales.',
    ]
  },
]

export default function Terms() {
  return (
    <section id="terms" style={{
      background: 'var(--bone)',
      padding: 'clamp(80px,12vw,140px) clamp(24px,5vw,56px) clamp(64px,10vw,120px)',
    }}>
      {/* Header */}
      <div style={{ marginBottom: 64 }}>
        <div style={{
          fontFamily: 'var(--f-m)', fontSize: 9, letterSpacing: '0.28em',
          textTransform: 'uppercase', color: 'rgba(0,0,0,0.3)', marginBottom: 16,
        }}>
          athomson.uk — Class Bookings
        </div>
        <h1 style={{
          fontFamily: 'var(--f-d)', fontSize: 'clamp(40px,7vw,80px)',
          letterSpacing: '0.04em', lineHeight: 1, marginBottom: 16, fontWeight: 400,
        }}>
          Terms &amp;<br />Conditions
        </h1>
        <p style={{
          fontSize: 13, fontWeight: 300, color: 'rgba(0,0,0,0.4)',
          lineHeight: 1.7, maxWidth: 480,
        }}>
          These terms apply to all class bookings made through athomson.uk. Please read them before completing your booking.
        </p>
      </div>

      {/* Sections */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {sections.map(s => (
          <div key={s.number} style={{
            background: '#111',
            color: 'var(--bone)',
            padding: 'clamp(28px,4vw,40px) clamp(24px,4vw,40px)',
            display: 'grid',
            gridTemplateColumns: '60px 1fr',
            gap: 'clamp(16px,3vw,40px)',
          }}>
            <div style={{
              fontFamily: 'var(--f-m)', fontSize: 9, letterSpacing: '0.2em',
              color: 'rgba(255,255,255,0.2)', paddingTop: 4,
            }}>
              {s.number}
            </div>
            <div>
              <div style={{
                fontFamily: 'var(--f-d)', fontSize: 'clamp(18px,2.5vw,24px)',
                letterSpacing: '0.06em', marginBottom: 16, color: 'var(--bone)',
              }}>
                {s.title}
              </div>
              {s.content.map((para, i) => (
                <p key={i} style={{
                  fontSize: 14, fontWeight: 300, color: 'rgba(255,255,255,0.5)',
                  lineHeight: 1.85, marginBottom: i < s.content.length - 1 ? 12 : 0,
                }}>
                  {para}
                </p>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Footer note */}
      <div style={{
        marginTop: 2, padding: 'clamp(20px,3vw,28px) clamp(24px,4vw,40px)',
        background: 'var(--pitch)', color: 'var(--bone)',
        display: 'flex', justifyContent: 'space-between',
        alignItems: 'center', flexWrap: 'wrap', gap: 12,
      }}>
        <span style={{
          fontFamily: 'var(--f-m)', fontSize: 9, letterSpacing: '0.18em',
          textTransform: 'uppercase', color: 'rgba(255,255,255,0.25)',
        }}>
          Last updated: July 2026
        </span>
        <a href="mailto:audrey@athomson.uk" style={{
          fontFamily: 'var(--f-m)', fontSize: 9, letterSpacing: '0.18em',
          textTransform: 'uppercase', color: 'rgba(255,255,255,0.4)',
          textDecoration: 'none',
        }}>
          Questions? audrey@athomson.uk
        </a>
      </div>
    </section>
  )
}
